import React, { createContext, useContext, PropsWithChildren } from "react";
import { IHprOptions } from "../models/IHprOptions";

const Context = createContext<IHprOptions | undefined>(undefined);

export const useHprContext = () => useContext(Context);

interface IHprProiderProps {
    options: IHprOptions;
}

export const HprProvider: React.FC<PropsWithChildren<IHprProiderProps>> = ({ options, children }) => {
    return (
        <Context.Provider value={options}>
            {children}
        </Context.Provider>
    );
};